import { render, staticRenderFns } from "./AppSectionCardDescription.vue?vue&type=template&id=9a7e8d3c&"
import script from "./AppSectionCardDescription.vue?vue&type=script&lang=js&"
export * from "./AppSectionCardDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports